import { IRequestBookingHistory } from 'interfaces'
import { IBookingHistoryResult } from 'interfaces/models.interface'
import { useCallback, useEffect, useState } from 'react'
import { bookingService } from 'services'

function useBookingHistory(searchParams?: IRequestBookingHistory, setError?: (error: any) => void) {
  const [bookingHistory, setBookingHistory] = useState<IBookingHistoryResult>()

  const setBookingHistoryResult = useCallback(
    (results_: IBookingHistoryResult) => {
      setBookingHistory((r) => {
        return {
          hasMore: results_.hasMore,
          data: [...(searchParams?.offset === 0 || !r?.data ? [] : r.data), ...results_.data],
        }
      })
    },
    [searchParams?.offset],
  )

  useEffect(() => {
    if (searchParams) {
      const controller = bookingService.bookingHistory(searchParams || {}, setBookingHistory, setError)
      return () => controller?.abort()
    }
  }, [searchParams, setError, setBookingHistoryResult])
  return bookingHistory
}

export default useBookingHistory
